/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type LlmRevokeRequest = {
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
  revokePermissionRequest: components.RevokePermissionRequest;
};

/** @internal */
export const LlmRevokeRequest$inboundSchema: z.ZodType<
  LlmRevokeRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  "X-On-Behalf-Of": z.string().optional(),
  RevokePermissionRequest: components.RevokePermissionRequest$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "X-On-Behalf-Of": "xOnBehalfOf",
    "RevokePermissionRequest": "revokePermissionRequest",
  });
});
/** @internal */
export type LlmRevokeRequest$Outbound = {
  "X-On-Behalf-Of"?: string | undefined;
  RevokePermissionRequest: components.RevokePermissionRequest$Outbound;
};

/** @internal */
export const LlmRevokeRequest$outboundSchema: z.ZodType<
  LlmRevokeRequest$Outbound,
  z.ZodTypeDef,
  LlmRevokeRequest
> = z.object({
  xOnBehalfOf: z.string().optional(),
  revokePermissionRequest: components.RevokePermissionRequest$outboundSchema,
}).transform((v) => {
  return remap$(v, {
    xOnBehalfOf: "X-On-Behalf-Of",
    revokePermissionRequest: "RevokePermissionRequest",
  });
});

export function llmRevokeRequestToJSON(
  llmRevokeRequest: LlmRevokeRequest,
): string {
  return JSON.stringify(
    LlmRevokeRequest$outboundSchema.parse(llmRevokeRequest),
  );
}
export function llmRevokeRequestFromJSON(
  jsonString: string,
): SafeParseResult<LlmRevokeRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => LlmRevokeRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'LlmRevokeRequest' from JSON`,
  );
}
